var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,0.106333288 L9,3.15002717 C5.57663952,3.84493267 3,6.87156313 3,10.5 C3,14.6421356 6.35786438,18 10.5,18 C14.6421356,18 18,14.6421356 18,10.5 C18,8.04627325 16.8216701,5.86776021 15,4.49945072 L15,1.01044675 C18.547421,2.69564265 21,6.31140607 21,10.5 C21,16.2989899 16.2989899,21 10.5,21 C4.70101013,21 1.80240098e-15,16.2989899 1.80240098e-15,10.5 C1.80240098e-15,5.21029214 3.91155879,0.834177779 9,0.106333288 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 12,
  y: -1.08733827e-15,
  width: 3,
  height: 9,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 12,
  y: -1.08733827e-15,
  width: 9,
  height: 3,
  rx: 1
}))));
export default SvgRefresh;